
export const convertUnixToDate = (unixTimestamp: string) => {
  if (!unixTimestamp) return "";
    const date = new Date(parseInt(unixTimestamp));
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
};

export const convertLongUnixToDate = (unixTimestamp?: number) : Date | null => {
    if (!unixTimestamp)
        return null;
    return new Date(unixTimestamp);
};

export const convertUtc = (date: Date | null) : Date | null => {
    if (date == null)
        return null;

    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}

export const convertUnixToFormateDate = (unixTimestamp: string): string => {
    if (!unixTimestamp) return "";
    if ("0" === unixTimestamp) return  "";

    const date = new Date(parseInt(unixTimestamp));

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear(); 

    return `${day}/${month}/${year}`;
};

export const convertIntUnixToFormateDate = (unixTimestamp: number): string => {
    if (!unixTimestamp) return "";
    if (0 === unixTimestamp) return "";

    const date = new Date(unixTimestamp);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export const convertIntUnixMilisegToFormateDate = (unixTimestamp: number): string => {
    if (!unixTimestamp) return "";

    const date = new Date(unixTimestamp);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

export const convertUnixMilisegToFormateDate = (unixTimestamp: string): string => {
    if (!unixTimestamp) return "";
    if ("0" === unixTimestamp) return "";

    const date = new Date(parseInt(unixTimestamp));

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

//convertir Date amb dd-mm-yyyy
export const convertDateToUnixWithTime = (dateString: string, timeOfDay?: '00:00' | '23:59'): number | null=> {
    // Dividir la cadena de fecha en componentes (d�a, mes, a�o)
    const dateParts = dateString.split('/');
    if (dateParts.length !== 3) {
        return null;  // Si no tiene el formato esperado, devolver null
    }

    const [day, month, year] = dateParts;
    if (isNaN(Number(day)) || isNaN(Number(month)) || isNaN(Number(year))) {
        return null; // Si alguno no es un n�mero, devolver null
    }
    // Formatear la fecha en formato 'yyyy-mm-dd'
    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

    // Crear un objeto Date con la fecha formateada
    const date = new Date(formattedDate);
    if (isNaN(date.getTime())) {
        return null; // Si la fecha no es v�lida, devolver null
    }
    if (timeOfDay) {
        if (timeOfDay === '00:00') {
            date.setHours(0, 0, 0, 0); // Hora al inicio del d�a
        } else if (timeOfDay === '23:59') {
            date.setHours(23, 59, 59, 0); // Hora al final del d�a
        }
    }

    // Convertir la fecha a Unix timestamp (segundos)
    return Math.floor(date.getTime()); // Convertir de milisegundos a segundos
};

/**
 * Formats ISO strings or Unix timestamps (sec/ms) to "dd/MM/yyyy".
 */
export const  formatDateDisplay = (value?: string | number | null): string => {
    if (!value) return "";

    let date: Date;

    if (typeof value === "number") {
        date = value.toString().length === 10
            ? new Date(value * 1000) 
            : new Date(value);
    } else {
        const trimmed = value.trim();

        if (/^\d+$/.test(trimmed)) {
            date = trimmed.length === 10
                ? new Date(parseInt(trimmed) * 1000)
                : new Date(parseInt(trimmed));
        } else {
            
            date = new Date(trimmed.endsWith("Z") ? trimmed : `${trimmed}Z`);
        }
    }

    if (isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};
